import * as types from '../constants/reportConstants';
import 'react-file-download';
import moment from 'moment';
import base64url from 'base64-url';
import * as filesaver from './FileSaver';
import {getPath} from './commonActions';
// To load report with given date range, sort and pagination
// export function ChnageAccount(acccode){
//  return{
//    types:[
//         types.LOAD_MARGIN,types.LOAD_MARGIN_SUCCESS,types.LOAD_MARGIN_FAILURE
//    ],
//    promise:(client) => client.get(`/loadposition?acccode=${acccode}`)
//  };
// }
export function ChnageAccount(accCode,UT,isOrders){
 return{
   type: types.LOAD_MARGIN,
   promise:(client) => client.get(`/getMargin?accCode=${accCode}&UT=${UT}&isOrders=${isOrders}`)
 };
}
export function loadReport(type, fromD, toD,filterType, filterValue) {
var obj={};
obj.type=type;
obj.startDate=fromD;
obj.endDate=toD;
obj.filterType=filterType;
obj.filterValue=filterValue;
obj.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    type:   types.LOAD_REPORT,
    promise: (client) => client.post('/TrdOrderHistory',{
    data: obj
  }),
  };
}

export function loadstatementOfaccountReport(accCode,type,fromD, toD,col1,col2,unit_code1,unit_code2,option,yearListHeading) {
  var obj={};
  obj.accCode=accCode;
  obj.orderBy=type;
  obj.startDate=fromD;
  obj.endDate=toD;
  obj.col1=col1;
  obj.col2=col2;
  obj.unit_code1=unit_code1;
  obj.unit_code2=unit_code2;
  obj.option=option;
  obj.Year=yearListHeading;
  return {
    type:  types.LOAD_SOA_REPORT,
    promise: (client) => client.post('/TrdAcctStmt',{
    data: obj
  }),
 };
}

export function loadAlldealReport(startDate,endDate,cmdtyKey,alldealTrd_optKey,alldealcreatby_optKey,alldealAcc_optKey,stkCode,yearListHeading) {
  var obj={};
  obj.startDate=startDate;
  obj.endDate=endDate;
  obj.cmdty=cmdtyKey;
  obj.docType=alldealTrd_optKey;
  obj.createdBy=alldealcreatby_optKey;
  obj.accCode=alldealAcc_optKey;
  obj.stkCode=stkCode;
  obj.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  obj.Year=yearListHeading;
  return {
    type:  types.LOAD_ALLDEAL_REPORT, 
    promise: (client) => client.post('/TrdDealRegister',{
    data: obj
  }),
  };
}
export function loadTradeRegReport(startDate,endDate,cmdtyKey,qnt_type,tradeType,orderStatus, fixingCode) {
  var obj={};
  obj.startDate=startDate;
  obj.endDate=endDate;
  obj.tradeType=tradeType;
  obj.orderType=orderStatus;
  obj.fc_code = fixingCode;
  obj.cmdty=cmdtyKey;
  obj.qtyType=qnt_type;
  obj.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    type: types.LOAD_TRADEREG_REPORT, 
    tradeType,
    promise: (client) => client.post('/SubTrdRegister',{
    data: obj
  }),
  };
}
export function loadOnlineReport(startDate,endDate,onlineCmdty_optKey,onlineOrder_optKey,onlineEventTimeKey,onlineAcc_optKey,onlinecreatby_optKey,qtyType) {
  var obj={};
  obj.startDate=startDate;
  obj.endDate=endDate;
  obj.cmdty=onlineCmdty_optKey;
  obj.status=onlineOrder_optKey;
  obj.dateType  =onlineEventTimeKey;
  obj.accCode=onlineAcc_optKey;
  obj.createdBy=onlinecreatby_optKey;
  obj.qtyType=qtyType;
  obj.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    type: types.LOAD_ONLINE_REPORT, 
    promise: (client) => client.post('/TrdOrderRegister',{
    data: obj
    }),
  };
}

export function loadBenchMarkReport(startDate,endDate,benchmark_Key,Order_opt,EventTime,creatby_opt,Acc_opt) {
   return {
   type:  types.LOAD_BENCHMARK_REPORT, 
   promise: (client) => client.get(`/benchMark_Report?startDate=${startDate}&endDate=${endDate}&benchmark_Key=${benchmark_Key}&Order_opt=${Order_opt}&EventTime=${EventTime}&creatby_opt=${creatby_opt}&Acc_opt=${Acc_opt}`)

 };
}
export function loadActivityReport(sessionType,startDate,endDate,orderBy) {
    const user = JSON.parse(localStorage.getItem('user'));
    const obj={};
    obj.OR=orderBy;
    obj.ID=user.UID;
    obj.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (sessionType ==='1'){
        //obj.FD=startDate;
      //  obj.TD=endDate;
        obj.SID=user.SID;
    }else if(sessionType ==='2'){
        const startDate= new Date();
        var sd = moment().startOf('day');
        // sd.set({hour:0,minute:0,second:0,millisecond:0})
        var ed = moment();
        //ed.set({hour:0,minute:0,second:0,millisecond:0})
        sd.format();
        ed.format();
        obj.FD=sd.utc().valueOf();
        obj.TD=ed.utc().valueOf();
    }else{
        var sd = moment(startDate, "DD-MM-YYYY");
        sd.format();
        var ed = moment(endDate, "DD-MM-YYYY").endOf('day');
        ed.format();
        obj.FD=sd.utc().valueOf();
        obj.TD=ed.utc().valueOf();
      }
    obj.userType='trader'
    return {
    type: types.LOAD_ACTIVITY_REPORT, 
    promise: (client) => client.post('/rptActLog',{
         data: obj
    }),
  };
}

export function getExportedReport(stDate, endDate,cmdty,Trd_opt,created_by,Acc_optKey,Qty_opt,format) {
  return {
    type :types.EXPORT_ALLDEAL_REPORT
  };
}
export function generateSOAPdf(accCode,type,fromD, toD,col1,col2,unit_code1,unit_code2,format,option,yearListHeading) {
  const user = JSON.parse(localStorage.getItem('user'));
  const platform = localStorage.getItem('platform');
  const region = navigator.language;
  let response = '';
  if (format === 'PDF') {
    var xhr = new XMLHttpRequest();
     xhr.open('GET',getPath("api")+'/user/export_SOA_pdf?startDate='+fromD+'&endDate='+toD+'&col1='+col1+'&col2='+col2+'&unit_code1='+unit_code1+'&unit_code2='+unit_code2+'&type='+type+'&option='+option+'&Year='+yearListHeading+'&region='+region, true);
     xhr.setRequestHeader('SID', user.SID);
     xhr.setRequestHeader('username', user.UID);
     xhr.setRequestHeader('userCode', user.UD);
     xhr.setRequestHeader('location', user.location);
     xhr.setRequestHeader('Cache-Control','no-cache');
     xhr.setRequestHeader('accCode',accCode);
     xhr.setRequestHeader('platform',platform);
     xhr.responseType = 'blob';
     xhr.onload = function (e) {
       if(col2!=="None"){
        filesaver.saveAs(xhr.response, "Rpt_SOA_Col2_Web" + fromD + "_to_" + toD + ".pdf");
     }else{
       filesaver.saveAs(xhr.response, "Rpt_SOA_Col1_Web" + fromD + "_to_" + toD + ".pdf");
     }
  }
   xhr.send();
} else {
    var xhr = new XMLHttpRequest();
     xhr.open('GET',getPath("api")+'/user/export_SOAReg_xls?startDate='+fromD+'&endDate='+toD+'&col1='+col1+'&col2='+col2+'&unit_code1='+unit_code1+'&unit_code2='+unit_code2+'&type='+type+'&option='+option, true);
     xhr.setRequestHeader('x-auth', user.authToken);
     xhr.setRequestHeader('username', user.id);
     xhr.setRequestHeader('location', user.location);
     xhr.setRequestHeader('userCode', user.name);
     xhr.setRequestHeader('Cache-Control','no-cache');
     xhr.setRequestHeader('AccCode',accCode);
     xhr.setRequestHeader('platform',platform);
     xhr.responseType = 'blob';
     xhr.onload = function (e) {
       if(col2!=="None"){
        filesaver.saveAs(xhr.response, "Rpt_SOA_Col2_Web" + fromD + "_to_" + toD + ".xlsx");
     }else{
       filesaver.saveAs(xhr.response, "Rpt_SOA_Col1_Web" + fromD + "_to_" + toD + ".xlsx");
     }
     }
     xhr.send();
  }
  return {
    type: types.EXPORT_SOA_REPORT,
  };
}
export function getExportPositionReport(acc_code,acc_desc,isOrders) {
  const user = JSON.parse(localStorage.getItem('user'));
  const userDetail = JSON.parse(localStorage.getItem('userDetail'));
  const platform = localStorage.getItem('platform');
  var clickTime = moment();
  clickTime.format();
  clickTime.utc().valueOf();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const region = navigator.language;
  let response = '';
    var xhr = new XMLHttpRequest();
     xhr.open('GET',getPath("api")+'/user/export_Margin_pdf?accCode='+acc_code+'&accDesc='+acc_desc+'&isOrders='+isOrders+'&clickTime='+clickTime+'&timezone='+timezone+'&region='+region);
     xhr.setRequestHeader('SID', user.SID);
     xhr.setRequestHeader('username', user.UID);
     xhr.setRequestHeader('location', user.location);
     xhr.setRequestHeader('platform', platform);
     xhr.setRequestHeader('Cache-Control','no-cache');
     xhr.responseType = 'blob';
     xhr.onload = function (e) {
        filesaver.saveAs(xhr.response, "Position_Keeping_Report_As on"+moment(new Date(), "dd-MMM-yyyy HH:mm:ss").toString()+".pdf");
     }
     xhr.send();
  return {
    type: types.EXPORT_POSITION_REPORT,
  };
}
export function getInvoice(docNo,docType,year='') {
  const user = JSON.parse(localStorage.getItem('user'));
  const userDetail = JSON.parse(localStorage.getItem('userDetail'));
  const platform = localStorage.getItem('platform');
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const region = navigator.language;
  let response = '';
  
  if(!year){
    year= userDetail.yearList[0].YEAR
  }

  var xhr = new XMLHttpRequest();
   xhr.open('GET',getPath("api") + '/user/export_FixInvoice_pdf?docNo='+docNo[0]+'&docType='+docType+'&timezone='+timezone+'&region='+region+'&year='+year);
   xhr.setRequestHeader('SID', userDetail.SID);
   xhr.setRequestHeader('username', userDetail.UID);
   xhr.setRequestHeader('location', user.location);
   xhr.setRequestHeader('Cache-Control','no-cache');
   xhr.setRequestHeader('platform',platform);
   xhr.responseType = 'blob';
   xhr.onload = function (e) {
      filesaver.saveAs(xhr.response, "Fixing_Invoice_"+docNo[0]+".pdf");
   }
   xhr.send();
  return {
    type: types.EXPORT_INVOICE_REPORT,
  };
}

export function resetStateReport(){
  return{
    type:types.RESET_STATE
  }
}

export function resetStateReportData(){
  return{
    type:types.RESET_REPORT_STATE
  }
}

export function generateActivityPdf(sessionType,startDate,endDate,orderBy,format,timezone) {
  const user = JSON.parse(localStorage.getItem('user'));
  const userDetail = JSON.parse(localStorage.getItem('userDetail'));
  const platform = localStorage.getItem('platform');
  const region = navigator.language;
  var xhr = new XMLHttpRequest();
  var clickTime = moment();
  clickTime.format();
  clickTime.utc().valueOf();
  if (sessionType ==='1'){
      // var FD=startDate;
      // var TD=endDate;
      var sd = moment();
      var ed = moment();
      sd.format();
      ed.format();
      var FD=sd.utc().valueOf();
      var TD=ed.utc().valueOf();
  }else if(sessionType ==='2'){
      const startDate= new Date();
      var sd = moment().startOf('day');
      // sd.set({hour:0,minute:0,second:0,millisecond:0})
      var ed = moment();
      // ed.set({hour:0,minute:0,second:0,millisecond:0})
      sd.format();
      ed.format();
      var FD=sd.utc().valueOf();
      var TD=ed.utc().valueOf();
  }else{
      var sd = moment(startDate, "DD-MM-YYYY");
      sd.format();
      var ed = moment(endDate, "DD-MM-YYYY").endOf('day');
      ed.format();
      var FD=sd.utc().valueOf();
      var TD=ed.utc().valueOf();
    }
      let response = '';
      if (format === 'PDF') {
        xhr.open('GET',getPath("api") + '/user/export_TrdActRpt_pdf?startDate='+FD+'&endDate='+TD+
        '&sessionType='+sessionType+'&orderBy='+orderBy+'&timezone='+timezone+'&clickTime='+clickTime+'&region='+region);
        xhr.setRequestHeader('SID', userDetail.SID);
        xhr.setRequestHeader('username', userDetail.UID);
        xhr.setRequestHeader('location', user.location);
        xhr.setRequestHeader('Cache-Control','no-cache');
        xhr.setRequestHeader('platform',platform);
        xhr.responseType = 'blob';
        xhr.onload = function (e) {
           filesaver.saveAs(xhr.response, "Activity_Log_Register_" + moment.unix(FD).format("DD/MM/YYYY") + "_to_" + moment.unix(TD).format("DD/MM/YYYY") + ".pdf");
        }
        xhr.send();
      } else {
        xhr.open('GET',getPath("api") + '/user/export_TrdActRpt_pdf?startDate='+FD+'&endDate='+TD+
        '&sessionType='+sessionType+'&orderBy='+orderBy+'&timezone='+timezone+'&region='+region);
        xhr.setRequestHeader('SID', userDetail.SID);
        xhr.setRequestHeader('username', userDetail.UID);
        xhr.setRequestHeader('location', user.location);
        xhr.setRequestHeader('Cache-Control','no-cache');
        xhr.setRequestHeader('userCode', );
        xhr.setRequestHeader('platform',platform);
        xhr.responseType = 'blob';
        xhr.onload = function (e) {
           filesaver.saveAs(xhr.response, "Activity_Log_Register_" + moment.unix(FD).format("DD/MM/YYYY") + "_to_" + moment.unix(TD).format("DD/MM/YYYY") +".xlsx");
        }
        xhr.send();
      }
      return {
        type: types.EXPORT_ACTIVITY_REPORT,
      };

}
export function encodeUrl(url){
  const getValue = url.toString().split('?');
  const id = getValue[0];
  const keyValue=getValue[1];
  var encode=base64url.encode(keyValue)
  const URL=id+"?data="+encode;
return URL
}
export function generateOHRPdf(type, startDate, endDate,filterType, filterValue,format) {
  const user = JSON.parse(localStorage.getItem('user'));
  const platform = localStorage.getItem('platform');
  let response = '';
  var xhr = new XMLHttpRequest();


  if (format === 'PDF') {
    xhr.open('GET',getPath("api") + '/user/export_OrderHistory_pdf?startDate='+startDate+'&endDate='+endDate+'&type='+type+'&filterType='+filterType+'&filterValue='+filterValue, true);
    xhr.setRequestHeader('x-auth', user.authToken);
    xhr.setRequestHeader('username', user.id);
    xhr.setRequestHeader('location', user.location);
    xhr.setRequestHeader('Cache-Control','no-cache');
    xhr.setRequestHeader('platform',platform);
    xhr.setRequestHeader('userCode',user.name);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
       filesaver.saveAs(xhr.response, "Order_History_Report_" + startDate + "_to_" + endDate + ".pdf");
    }
    xhr.send();
  } else {
    xhr.open('GET',getPath("api") + '/user/export_OrderHistory_xls?startDate='+startDate+'&endDate='+endDate+'&type='+type+'&filterType='+filterType+'&filterValue='+filterValue, true);
    xhr.setRequestHeader('x-auth', user.authToken);
    xhr.setRequestHeader('username', user.id);
    xhr.setRequestHeader('location', user.location);
    xhr.setRequestHeader('Cache-Control','no-cache');
    xhr.setRequestHeader('platform',platform);
    xhr.setRequestHeader('userCode',user.name);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
       filesaver.saveAs(xhr.response, "Order_History_Report_" + startDate + "_to_" + endDate +".xlsx");
    }
    xhr.send();
  }
  return {
    type: types.EXPORT_ORDER_HISTORY_REPORT,
  };
}
export function generateOnlReportPdf(startDate,endDate,Cmdty_opt,EventTime,Acc_opt,creatby_opt,Order_opt,format,Acc_Desc,qtyType) {
  const user = JSON.parse(localStorage.getItem('user'));
  const platform = localStorage.getItem('platform');
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const region = navigator.language;
  let response = '';
  let fileName;
  var xhr = new XMLHttpRequest();
  if (Order_opt==="O") {
				fileName = "Online_Orders_Out_";
			} else if (Order_opt==="F") {
				fileName = "Online_Orders_Fill_";
			} else if (Order_opt==="C") {
				fileName = "Online_Orders_Can_";
			} else if (Order_opt==="E") {
				fileName = "Online_Orders_Exp_";
			} else {
				fileName = "Online_Orders_All_";
			}
  if (format === 'PDF') {
    xhr.open('GET',getPath("api") + '/user/export_OnlOrder_pdf?startDate='+startDate+'&endDate='+endDate+'&cmdty='+Cmdty_opt+'&dateType='+EventTime+'&createdBy='+creatby_opt+'&status='+Order_opt+'&timezone='+timezone+'&qtyType='+qtyType+'&region='+region, true);
    xhr.setRequestHeader('username', user.UID);
    xhr.setRequestHeader('location', user.location);
    xhr.setRequestHeader('Cache-Control','no-cache');
    xhr.setRequestHeader('platform',platform);
    xhr.setRequestHeader('userCode',user.UD);
    xhr.setRequestHeader('accCode',Acc_opt);
    xhr.setRequestHeader('accDesc',Acc_Desc);
    xhr.setRequestHeader('SID',user.SID);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
       filesaver.saveAs(xhr.response, fileName+startDate+"_to_"+endDate+".pdf");
    }
    xhr.send();
  } else {
    xhr.open('GET',getPath("api") + '/user/export_OnlOrder_xls?startDate='+startDate+'&endDate='+endDate+'&Cmdty='+Cmdty_opt+'&EventTime='+EventTime+'&creatby_opt='+creatby_opt+'&Order_opt='+Order_opt, true);
    xhr.setRequestHeader('x-auth', user.authToken);
    xhr.setRequestHeader('username', user.id);
    xhr.setRequestHeader('location', user.location);
    xhr.setRequestHeader('Cache-Control','no-cache');
    xhr.setRequestHeader('platform',platform);
    xhr.setRequestHeader('userCode',user.name);
    xhr.setRequestHeader('Accopt',Acc_opt);
    xhr.setRequestHeader('AccDesc',Acc_Desc);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
       filesaver.saveAs(xhr.response, fileName+startDate+"_to_"+endDate+".xlsx");
    }
    xhr.send();
  }
  return {
    type: types.EXPORT_ONLINE_ORDER_REPORT,
  };
}
export function generateBMReportPdf(startDate,endDate,benchmark,Order_Status,EventTime,Acc_opt,creatby_opt,format,Acc_Desc) {
  const user = JSON.parse(localStorage.getItem('user'));
  const platform = localStorage.getItem('platform');
  var xhr = new XMLHttpRequest();
  var fileName;
    if (Order_Status==="O") {
      fileName = "BenchMark_Orders_Out_";
  } else if (Order_Status==="F") {
      fileName = "BenchMark_Orders_fill_";
  } else {
      fileName = "BenchMark_Orders_can_";
  }
  let response = '';
  if (format === 'PDF') {
    xhr.open('GET',getPath("api") + '/user/export_BMRpt_pdf?startDate='+startDate+'&endDate='+endDate+'&benchMark='+benchmark+'&EventTime='+EventTime+'&creatby_opt='+creatby_opt+'&Order_Status='+Order_Status, true);
    xhr.setRequestHeader('x-auth', user.authToken);
    xhr.setRequestHeader('username', user.id);
    xhr.setRequestHeader('location', user.location);
    xhr.setRequestHeader('Cache-Control','no-cache');
    xhr.setRequestHeader('platform',platform);
    xhr.setRequestHeader('userCode',user.name);
    xhr.setRequestHeader('Accopt',Acc_opt);
    xhr.setRequestHeader('AccDesc',Acc_Desc);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
       filesaver.saveAs(xhr.response, fileName+startDate+"_to_"+endDate+".pdf");
    }
    xhr.send();
  } else {
    xhr.open('GET',getPath("api") + '/user/export_BMRpt_xls?startDate='+startDate+'&endDate='+endDate+'&benchMark='+benchmark+'&EventTime='+EventTime+'&creatby_opt='+creatby_opt+'&Order_Status='+Order_Status, true);
    xhr.setRequestHeader('x-auth', user.authToken);
    xhr.setRequestHeader('username', user.id);
    xhr.setRequestHeader('location', user.location);
    xhr.setRequestHeader('Cache-Control','no-cache');
    xhr.setRequestHeader('platform',platform);
    xhr.setRequestHeader('userCode',user.name);
    xhr.setRequestHeader('Accopt',Acc_opt);
    xhr.setRequestHeader('AccDesc',Acc_Desc);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
       filesaver.saveAs(xhr.response, fileName+startDate+"_to_"+endDate+".xlsx");
    }
    xhr.send();
  }
  return {
    type: types.EXPORT_BM_REPORT,
  };

}
export function setLoaderFlag(flag) {
  return {
    type: types.ENABLE_LOADER,
    flag
  };
}

export function getTradeanalysisReport(accCode, stk_type, startDate, endDate, qtyType, rate, openBal, langcode, tradeType) {
  var obj={};
  obj.startDate= startDate;
  obj.endDate = endDate;
  obj.accCode = accCode;
  obj.stkType = stk_type;
  obj.qtyType = qtyType;
  obj.rate = rate.toString();
  obj.isOpen = openBal.toString();
  obj.tradeType = tradeType.toString();
  obj.langCode = langcode;
  return {
    type: types.LOAD_TRADE_ANALYSIS, 
    promise: (client) => client.post('/TradeAnalysis',{
    data:obj,
  }),
 };
}

export function loadFixingReport(FixingCode,startDate,endDate,IID,orderType,fixEventTimeKey,account,createdBy,qtyType,fixDateType) {
  var obj={};
  // var fixingDateType;
  // if(orderType==="O"){
  //   fixingDateType=fixDateType;
  // }
  // else {
  //     fixingDateType="ALL";
  // }
  obj.acc_Code=account;
  obj.fc_code=FixingCode;
  obj.IID=IID;
  obj.status=orderType;
  obj.DD  =fixEventTimeKey;
  obj.DT=-1;
  obj.fromDate=startDate;
  obj.toDate=endDate;
  obj.qtyType=qtyType;
  obj.SD=createdBy;
  obj.fixDateType=fixDateType;
  obj.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return {
    type: types.LOAD_FIXING_REPORT, 
    promise: (client) => client.post('/TrdFixOrdReg',{
    data: obj
    }),
  };
}
export function generateFixReportPdf(FixingCode,startDate,endDate,orderType,fixEventTimeKey,account,createdBy,qtyType,Acc_Desc,format,fixDateType,Order_opt,Acc_opt,instId){
  const user = JSON.parse(localStorage.getItem('user'));
  const platform = localStorage.getItem('platform');
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const region = navigator.language;
  let fileName;
  var xhr = new XMLHttpRequest();
  let fixingDateType;
  if (Order_opt==="O") {
				fileName = "fixing_Orders_Out_";
			} else if (Order_opt==="F") {
				fileName = "fixing_Orders_Fill_";
			} else {
				fileName = "fixing_Orders_Can_";
			}
  if (format === 'PDF') {
    xhr.open('GET',getPath("api") + '/user/export_TrdFixingOrder_pdf?accCode='+account+'&accDesc='+Acc_Desc+'&DD='+fixEventTimeKey+'&fromDate='+startDate+'&toDate='+endDate+'&qtyType='+qtyType+'&status='+orderType+'&fcCode='+FixingCode+'&createdBy='+createdBy+'&timezone='+timezone+'&fixDateType='+fixDateType+'&instId='+instId+'&DT='+-1+'&region='+region, true);
    xhr.setRequestHeader('username', user.UID);
    xhr.setRequestHeader('location', user.location);
    xhr.setRequestHeader('Cache-Control','no-cache');
    xhr.setRequestHeader('platform',platform);
    xhr.setRequestHeader('userCode',user.UD);
    xhr.setRequestHeader('accCode',Acc_opt);
    xhr.setRequestHeader('accDesc',Acc_Desc);
    xhr.setRequestHeader('SID',user.SID);
    xhr.responseType = 'blob';
    xhr.onload = function (e) {
       filesaver.saveAs(xhr.response, fileName+startDate+"_to_"+endDate+".pdf");
    }
    xhr.send();
  }
   else {
     xhr.open('GET',getPath("api") + '/user/export_TrdFixingOrder_xls?accCode='+account+'&accDesc='+Acc_Desc+'&DD='+fixEventTimeKey+'&fromDate='+startDate+'&toDate='+endDate+'&qtyType='+qtyType+'&status='+orderType+'&fcCode='+FixingCode+'&createdBy='+createdBy+'&timezone='+timezone+'&fixDateType='+fixDateType+'&instId='+instId+'&DT='+-1+'&region='+region, true);
     xhr.setRequestHeader('username', user.UID);
     xhr.setRequestHeader('location', user.location);
     xhr.setRequestHeader('Cache-Control','no-cache');
     xhr.setRequestHeader('platform',platform);
     xhr.setRequestHeader('userCode',user.UD);
     xhr.setRequestHeader('accCode',Acc_opt);
     xhr.setRequestHeader('accDesc',Acc_Desc);
     xhr.setRequestHeader('SID',user.SID);
     xhr.responseType = 'blob';
     xhr.onload = function (e) {
        filesaver.saveAs(xhr.response, fileName+startDate+"_to_"+endDate+".xlsx");;
    }
    xhr.send();
  }
  return {
    type: types.EXPORT_FIXING_ORDER_REPORT,
  };
}
